export default "__VITE_ASSET___aaws84J__"